export const fuelColors = {
  Bencina: '#13CE66',
  Diésel: '#7D67BC',
  Híbrido: '#6185DB',
  Eléctrico: '#FAD901',
}
